import { useDispatch } from "react-redux"
import {
  setCreativesLoading,
  setCreativesError,
  updateCreativeSuccess,
} from "../redux/slices/creativesSlice"
import { updateCreative } from "../services/creatives/updateCreative"
import { getDuplicateCreativeUrlFromCDN } from "../services/ml/getDuplicateCreativeUrl"

export const useCreatives = () => {
  const dispatch = useDispatch()

  const handleUpdateCreative = async (creativeId, updateData) => {
    try {
      dispatch(setCreativesLoading(true))
      const updatedCreative = await updateCreative(creativeId, updateData)
      dispatch(updateCreativeSuccess(updatedCreative))
      return updatedCreative
    } catch (error) {
      dispatch(setCreativesError(error.message))
      throw error
    } finally {
      dispatch(setCreativesLoading(false))
    }
  }

  return {
    handleUpdateCreative,
  }
}

export const useDuplicateCreatives = () => {

  const handleGetDuplicateCreativeUrls = async (creatives) => {
    try {
      const creativeWithDuplicateUrls = await Promise.all(
        creatives.map(async (creative) => {
          const data = {
            creative_id: creative._id,
            user_id: creative.userId,
          }
          const response = await getDuplicateCreativeUrlFromCDN(data)
          const duplicateUrl = response.data.creative_url
          return { ...creative, duplicateUrl }
        })
      )
      return creativeWithDuplicateUrls
    } catch (error) {
      console.error("Error getting duplicate creative urls:", error)
      return null
    }
  }

  return {
    handleGetDuplicateCreativeUrls,
  }
}
